import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import i18n from 'i18n';
import Scrollbars from 'react-custom-scrollbars-2';
import OutsideClickHandler from 'react-outside-click-handler';

import SupportedLanguages from 'constants/SupportedLanguages';

import style from './LanguageSwitcher.module.scss';
import { ExpandIcon } from 'components/common/icons';
import cn from 'classnames';

const LanguageSwitcher = ({
    selectorWrapperClassName,
    selectorClassName,
    optionClassName,
    previewClassName,
    withIcon,
    iconClassName,
    iconFill,
}) => {
    const [loadedLanguages, setLoadedLanguages] = useState([]);
    const [selectorOpen, setSelectorOpen] = useState(false);
    const setDayjsLocale = (language) => {
        if (loadedLanguages.includes(language)) return dayjs.locale(language);
        import(`dayjs/locale/${language}.js`)
            .then(() => {
                dayjs.locale(language);
                setLoadedLanguages((state) => [...state, language]);
            })
            .catch((e) => console.log(e));
    };
    const handleSelectorClose = () => setSelectorOpen(false);
    const handleSelectorToggle = () => setSelectorOpen(!selectorOpen);

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setDayjsLocale(language);
    };

    useEffect(() => {
        setDayjsLocale(i18n.language);
    }, []);

    const renderLanguageName = (language) => {
        if (!language) return '';
        // eslint-disable-next-line no-useless-escape
        let [_, country] = language.split(/[\-|_]/);
        let langString = i18n.t(`selfName:name`, { lng: language });
        if (country) langString += ` (${i18n.t(`countries.${country}`, { lng: language })})`;
        return langString;
    };

    const selectorWrapper = cn(style.selectorContainer, selectorWrapperClassName);
    const selectorStyle = cn(style.selector, selectorClassName);
    const optionStyle = cn(style.option, optionClassName);
    const previewStyle = cn(style.selectedLanguage, previewClassName);
    const iconStyle = cn(style.icon, iconClassName, { [style.opened]: selectorOpen });

    return (
        <OutsideClickHandler onOutsideClick={handleSelectorClose}>
            <div className={selectorWrapper}>
                <div className={previewStyle} onClick={handleSelectorToggle}>
                    <div className={style.lang}>{renderLanguageName(i18n.language)}</div>
                    {withIcon && <ExpandIcon className={iconStyle} fill={iconFill} />}
                </div>
                {selectorOpen && (
                    <div className={selectorStyle}>
                        <Scrollbars>
                            {SupportedLanguages.map((lang) => (
                                <div
                                    className={optionStyle}
                                    key={lang}
                                    onClick={() => {
                                        changeLanguage(lang);
                                        handleSelectorClose();
                                    }}
                                >
                                    {renderLanguageName(lang)}
                                </div>
                            ))}
                        </Scrollbars>
                    </div>
                )}
            </div>
        </OutsideClickHandler>
    );
};

export default LanguageSwitcher;
